import React from 'react';
import { useNavigate } from 'react-router-dom';
import Icon from '../../../components/AppIcon';
import Button from '../../../components/ui/Button';

const SuccessModal = ({ isOpen, onClose }) => {
  const navigate = useNavigate();

  if (!isOpen) return null;

  const handleViewPost = () => {
    navigate('/main-feed');
  };

  return (
    <div className="fixed inset-0 z-[200] flex items-center justify-center p-4 bg-background/80 backdrop-blur-sm">
      <div className="w-full max-w-md bg-card border border-border rounded-lg shadow-lg overflow-hidden">
        <div className="p-6 md:p-8 text-center">
          <div className="flex items-center justify-center w-16 h-16 md:w-20 md:h-20 bg-success/10 rounded-full mx-auto mb-4 md:mb-6">
            <Icon name="CheckCircle2" size={32} color="var(--color-success)" strokeWidth={2} />
          </div>

          <h3 className="text-xl md:text-2xl font-semibold text-foreground mb-3">
            Your Story Has Been Shared
          </h3>

          <p className="text-sm md:text-base text-muted-foreground leading-relaxed mb-6">
            Thank you for trusting our community with your feelings. Your anonymous post is now live and others can offer their support through reactions.
          </p>

          <div className="space-y-3">
            <Button
              variant="default"
              onClick={handleViewPost}
              iconName="ArrowRight"
              iconPosition="right"
              fullWidth
            >
              View in Feed
            </Button>
            <Button
              variant="outline"
              onClick={onClose}
              fullWidth
            >
              Share Another Story
            </Button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default SuccessModal;